<template>
    <section class="koko-tips container">
        <div v-for="tip in list" :class="['item', tip.type]">
            <figure v-if="tip.type && tip.type === 'image'">
                <img v-bind:src="tip.image" alt="Koko Avatar" />
            </figure>
            <div v-else @click="handleModal(tip)" role="button" :aria-label="tip.title" >
                <h3 class="title" v-html="tip.title"></h3>
                <i class="fa fa-chevron-down"></i>
            </div>
        </div>

        <modal :name="customModalName">
            <h2 slot="header" v-html="tip.title"></h2>
            <div slot="body" v-html="tip.description"></div>
        </modal>
    </section>
</template>

<style lang="scss" scoped>
    .koko-tips {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        margin: 24px auto 32px;

        @media (min-width: 992px) {
            flex-wrap: nowrap;
        }

        @media (max-width: 991px) {
            margin: 0px auto 32px;
        }

        figure  {
            width: 88px;
            height: 88px;
            margin: 0;
        }
    }

    .item:not(.image) {
        position: relative;
        border-radius: 15px;
        cursor: pointer;
        transition: all .3s;
        margin: 10px 0;

        background: rgba(0, 199, 166, 1);
        background: linear-gradient(58deg, rgba(107, 219, 137, 1) 0%, rgba(0, 199, 166, 1) 100%);
        color: #FFF;
        transition: background .2s;
        width: calc(100% - 110px);

        &:hover {
            background: linear-gradient(10deg, rgba(107, 219, 137, 1) 0%, rgba(0, 199, 166, 1) 100%);
        }

        &:first-child {
            width: 100%;
            background: #5C00AA;
            background: linear-gradient(58deg, rgba(92, 0, 170, 1) 0%, rgba(148, 0, 202, 1) 100%);
            transition: background .2s;

            &:hover {
                background: linear-gradient(10deg, rgba(73, 18, 119, 1) 0%, rgba(117, 2, 159, 1) 100%);
            }
        }

        > div {
            padding: 16px 55px 16px 16px;
        }

        @media (min-width: 992px) {
            width: 40%;
            max-width: 430px;
            margin: 0 10px;

            &:first-child {
                width: 60%;
                max-width: 595px;
            }
        }
    }

    h3 {
        font-size: 1rem;
        line-height: 1.3em;
        font-weight: 400;
        margin: 0;

        @media (min-width: 992px) {
            font-size: 1.2rem;
        }
    }

    .fa {
        position: absolute;
        top: 50%;
        right: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        border: 1px solid #FFF;
        border-radius: 24px;
        font-size: 12px;
        transform: translateY(-50%);
    }
</style>

<script>
    import Modal from '../modal/ModalWrapper.vue'

    export default {
        props: {
            list: {
                type: Array,
                required: true,
            },
        },
        components: {
            Modal
        },
        data() {
            return {
                tip: {},
                customModalName: 'koko',
            }
        },
        methods: {
            handleModal: function(tip) {
                this.tip = tip
                this.$root.toggleModal(this.customModalName)
            }
        }
    }
</script>
